import '../../utils/swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/zoom';

import '~/styles/main.css';

import { productGallery } from '../snippets/product-gallery';
import { productInfo } from '../snippets/product-info';
import { initTestimonialCarousel } from '../sections/featured-testimonial';
import { initBuyBoxAccordion } from '../sections/buy-box-accordion';

const galleryInstance = productGallery();

galleryInstance.init();
productInfo.initializeEvents();
initTestimonialCarousel();
initBuyBoxAccordion();
